// extracted by mini-css-extract-plugin
export default {"beamTrueDropdownButton":"beam-true-dropdown-menu_beamTrueDropdownButton__x2WOf"};